// extracted by mini-css-extract-plugin
module.exports = {"socialicons":"social-icons_socialicons__2NVdH"};